<div class="quotation-notification-dialog">
  <mat-dialog-content class="max-height-100-vh">
    <div class="row">
      <div class="col-12">
        <div class="mat-subtitle-1 header">Send Quotation To</div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 email-list">
        <mat-form-field class="cc-email-chip-list">
          <mat-label>Email Addresses*</mat-label>
          <mat-chip-grid #chipList aria-label="email list">
            @for (email of emailList; track email) {
              <mat-chip-row (removed)="remove(email)">
                {{email}}
                <button matChipRemove>
                  <span class="mdi mdi-close"></span>
                </button>
              </mat-chip-row>
            }
            <input [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              [formControl]="formControlEmail"
              (matChipInputTokenEnd)="add($event)">
            </mat-chip-grid>
          </mat-form-field>
          @if (emailError) {
            <span class="error">
              Please enter a valid email
            </span>
          }
      </div>
    </div>

    <div class="row separator-top">
      <div class="col" fxLayout="row" fxLayoutAlign="space-between center">
        <button mat-stroked-button (click)="onCancel()">Cancel</button>
        @if (emailList) {
          <button mat-flat-button color="primary" [disabled]="emailError || !(emailList.length)" (click)="onSubmit()">Send</button>
        }
      </div>
    </div>
  </mat-dialog-content>
</div>
 